import { ADJUST_SCROLL_TO_HASH_THRESHOLD } from './constants';
import { ApplicationState } from './types';

// scroll the page to the right position for url for
// - comment permalink e.g. https://openlearning.com/courses/course-one/page/...#comment-61b66980b9cb61411e33bf18
// - link to header anchor e.g. https://openlearning.com/courses/course-one/page/?cl=1#h_93360661361639003111957
//
// this dispatcher gets called when
// - the comments get loaded
// - the height of the block page content changes, which can be caused by
//   widgets are loaded or images get loaded eventually
export const scrollToHashForLink = (state: ApplicationState): void => {
  const { hash } = window.location;
  const { firstScrolledToHash } = state;

  if (!hash) return;

  if (
    firstScrolledToHash &&
    // Allows the scroll position to be re-adjust for a grace period after
    // the first scroll.
    // Ideally we only need to scroll once, but most of the time we need to
    // deal with continuous loading content, where the element with hash
    // gets pushed down.
    // Alternatively, we can check when the last time we scroll - but
    // that might result in recursive scrolling (think infinite scroll)
    Date.now() - firstScrolledToHash > ADJUST_SCROLL_TO_HASH_THRESHOLD
  )
    return;

  // first, search for element that has the hash as id (e.g. comment)
  let element: Element | null = document.querySelector(hash);

  if (!element) {
    // now search for heading anchor in text widgets
    // e.g. <a href="#h_93360661361639003111957">Header 3</a>
    const iFrames = document.querySelectorAll(
      'safe-richtext > iframe'
    ) as NodeListOf<HTMLIFrameElement>;

    if (iFrames) {
      Array.from(iFrames).some((iframe) => {
        const match = iframe.contentWindow
          ? iframe.contentWindow.document.body.querySelector(`[href="${hash}"]`)
          : null;
        if (match) {
          element = match;
          return true;
        }
        return false;
      });
    }
  }

  if (element) {
    // behavior: 'smooth' allows smoother scroll animation, but doesn't work
    // too well, so I took it out
    element.scrollIntoView({
      block: 'center',
    });

    if (!firstScrolledToHash) {
      state.firstScrolledToHash = Date.now();
    }
  }
};
